import React, { useState, useEffect } from 'react';
import { translatedMessage } from '../../service/LanguageService';
// import { Checkbox } from 'primereact/checkbox';
import GeneralUtils from '../../utilities/GeneralUtils';

const CompetitionTrainingReqViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        // console.log(props?.competition);
        setCompetition(props?.competition);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    return (
        <>
            {
                <div className='col-12 mt-5'>
                    <h5>{translatedMessage('competition.requirements.training.info')}</h5>
                    <div className="w-full grid">
                        {/* <div className='col-4 lg:col-2'>
                            <div className="field-checkbox text-left mb-0 pt-2">
                                <Checkbox inputId="trainingRequired" name="trainingRequired" checked={competition?.trainingRequired} disabled />
                                <label htmlFor="trainingRequired">{translatedMessage("competition.requirements.training.info") + ": "}</label>
                            </div>
                        </div>
                        <div className='col-8 lg:col-10'>
                            <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.training)}</div>
                        </div> */}
                        <div className='col-8 lg:col-10'>
                            <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.training)}</div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default CompetitionTrainingReqViewComponent;
